import { useLottie } from 'lottie-react';
import animation from "./animation.json"


const Loading = ({ style = {} }) => {

  const options = {

    animationData: animation,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options, style);

  return View;

}

export default Loading